(function () {
  function initFlipbook(section) {
    if (section.dataset.flipbookReady === '1') return;

    var container = section.querySelector('[data-flipbook]');
    if (!container) return;

    if (typeof St === 'undefined' || !St.PageFlip) {
      console.warn('[catalog-flipbook] StPageFlip not loaded yet, retrying.');
      requestAnimationFrame(function () {
        initFlipbook(section);
      });
      return;
    }

    var pageNodes = container.querySelectorAll('.catalog-flipbook__page');
    if (!pageNodes.length) return;

    var prevBtn = section.querySelector('[data-flipbook-prev]');
    var nextBtn = section.querySelector('[data-flipbook-next]');
    var currentEl = section.querySelector('[data-flipbook-current]');
    var totalEl = section.querySelector('[data-flipbook-total]');

    var pageFlip = new St.PageFlip(container, {
      width: 550,
      height: 712,
      size: 'stretch',
      minWidth: 280,
      maxWidth: 700,
      minHeight: 362,
      maxHeight: 906,
      maxShadowOpacity: 0.5,
      showCover: true,
      mobileScrollSupport: false,
      flippingTime: 800,
      drawShadow: true,
      usePortrait: true,
      autoSize: true,
    });

    pageFlip.loadFromHTML(pageNodes);

    function updateCounter() {
      if (currentEl) currentEl.textContent = pageFlip.getCurrentPageIndex() + 1;
      if (totalEl) totalEl.textContent = pageFlip.getPageCount();
      updateNavState();
    }

    function updateNavState() {
      var idx = pageFlip.getCurrentPageIndex();
      var total = pageFlip.getPageCount();
      if (prevBtn) prevBtn.disabled = idx <= 0;
      if (nextBtn) nextBtn.disabled = idx >= total - 1;
    }

    pageFlip.on('flip', updateCounter);
    pageFlip.on('init', updateCounter);
    pageFlip.on('changeOrientation', updateCounter);

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        pageFlip.flipPrev();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        pageFlip.flipNext();
      });
    }

    section.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        pageFlip.flipPrev();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        pageFlip.flipNext();
      }
    });

    section.classList.remove('catalog-flipbook--loading');
    section.dataset.flipbookReady = '1';
    updateCounter();
  }

  function init() {
    document.querySelectorAll('[data-flipbook-section]').forEach(initFlipbook);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-flipbook-section]');
    if (section) initFlipbook(section);
  });
})();
